import { render, staticRenderFns } from "./tableFour.vue?vue&type=template&id=65837b36&scoped=true&"
import script from "./tableFour.vue?vue&type=script&lang=js&"
export * from "./tableFour.vue?vue&type=script&lang=js&"
import style0 from "./tableFour.vue?vue&type=style&index=0&id=65837b36&lang=scss&scoped=true&"
import style1 from "./tableFour.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65837b36",
  null
  
)

export default component.exports